"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.array.map.js");
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _get = _interopRequireDefault(require("lodash/get"));
var _reject = _interopRequireDefault(require("lodash/reject"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _DropDown = _interopRequireDefault(require("./DropDown"));
var _type = require("./type");
var _jsxFileName = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/MultiDropDown/lib/MultiDropDown.js",
  _templateObject,
  _templateObject2,
  _templateObject3,
  _templateObject4,
  _templateObject5,
  _templateObject6,
  _templateObject7,
  _templateObject8,
  _templateObject9,
  _templateObject10,
  _templateObject11,
  _templateObject12,
  _templateObject13,
  _templateObject14,
  _templateObject15,
  _templateObject16,
  _templateObject17,
  _templateObject18;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_21ccn4jg1n() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/MultiDropDown/lib/MultiDropDown.js";
  var hash = "a337dec0c2513299158c1139c0880a5858aa5fb8";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/MultiDropDown/lib/MultiDropDown.js",
    statementMap: {
      "0": {
        start: {
          line: 24,
          column: 16
        },
        end: {
          line: 60,
          column: 1
        }
      },
      "1": {
        start: {
          line: 34,
          column: 8
        },
        end: {
          line: 35,
          column: 39
        }
      },
      "2": {
        start: {
          line: 53,
          column: 25
        },
        end: {
          line: 53,
          column: 54
        }
      },
      "3": {
        start: {
          line: 62,
          column: 21
        },
        end: {
          line: 73,
          column: 1
        }
      },
      "4": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 58
        }
      },
      "5": {
        start: {
          line: 71,
          column: 48
        },
        end: {
          line: 71,
          column: 78
        }
      },
      "6": {
        start: {
          line: 75,
          column: 22
        },
        end: {
          line: 102,
          column: 1
        }
      },
      "7": {
        start: {
          line: 80,
          column: 19
        },
        end: {
          line: 80,
          column: 49
        }
      },
      "8": {
        start: {
          line: 90,
          column: 30
        },
        end: {
          line: 90,
          column: 74
        }
      },
      "9": {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 97,
          column: 69
        }
      },
      "10": {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 100,
          column: 37
        }
      },
      "11": {
        start: {
          line: 104,
          column: 24
        },
        end: {
          line: 158,
          column: 1
        }
      },
      "12": {
        start: {
          line: 111,
          column: 26
        },
        end: {
          line: 111,
          column: 53
        }
      },
      "13": {
        start: {
          line: 113,
          column: 32
        },
        end: {
          line: 113,
          column: 60
        }
      },
      "14": {
        start: {
          line: 115,
          column: 8
        },
        end: {
          line: 118,
          column: 25
        }
      },
      "15": {
        start: {
          line: 120,
          column: 8
        },
        end: {
          line: 121,
          column: 39
        }
      },
      "16": {
        start: {
          line: 140,
          column: 27
        },
        end: {
          line: 140,
          column: 87
        }
      },
      "17": {
        start: {
          line: 141,
          column: 29
        },
        end: {
          line: 141,
          column: 95
        }
      },
      "18": {
        start: {
          line: 160,
          column: 14
        },
        end: {
          line: 187,
          column: 1
        }
      },
      "19": {
        start: {
          line: 168,
          column: 8
        },
        end: {
          line: 169,
          column: 39
        }
      },
      "20": {
        start: {
          line: 178,
          column: 10
        },
        end: {
          line: 183,
          column: 11
        }
      },
      "21": {
        start: {
          line: 189,
          column: 20
        },
        end: {
          line: 248,
          column: 1
        }
      },
      "22": {
        start: {
          line: 196,
          column: 27
        },
        end: {
          line: 196,
          column: 73
        }
      },
      "23": {
        start: {
          line: 198,
          column: 8
        },
        end: {
          line: 199,
          column: 39
        }
      },
      "24": {
        start: {
          line: 200,
          column: 31
        },
        end: {
          line: 200,
          column: 71
        }
      },
      "25": {
        start: {
          line: 204,
          column: 8
        },
        end: {
          line: 204,
          column: 90
        }
      },
      "26": {
        start: {
          line: 205,
          column: 26
        },
        end: {
          line: 205,
          column: 66
        }
      },
      "27": {
        start: {
          line: 206,
          column: 29
        },
        end: {
          line: 206,
          column: 92
        }
      },
      "28": {
        start: {
          line: 208,
          column: 8
        },
        end: {
          line: 213,
          column: 7
        }
      },
      "29": {
        start: {
          line: 216,
          column: 8
        },
        end: {
          line: 220,
          column: 9
        }
      },
      "30": {
        start: {
          line: 224,
          column: 27
        },
        end: {
          line: 224,
          column: 73
        }
      },
      "31": {
        start: {
          line: 228,
          column: 25
        },
        end: {
          line: 228,
          column: 85
        }
      },
      "32": {
        start: {
          line: 230,
          column: 12
        },
        end: {
          line: 230,
          column: 72
        }
      },
      "33": {
        start: {
          line: 233,
          column: 8
        },
        end: {
          line: 238,
          column: 7
        }
      },
      "34": {
        start: {
          line: 241,
          column: 8
        },
        end: {
          line: 245,
          column: 9
        }
      },
      "35": {
        start: {
          line: 250,
          column: 16
        },
        end: {
          line: 261,
          column: 1
        }
      },
      "36": {
        start: {
          line: 257,
          column: 35
        },
        end: {
          line: 257,
          column: 47
        }
      },
      "37": {
        start: {
          line: 262,
          column: 14
        },
        end: {
          line: 304,
          column: 1
        }
      },
      "38": {
        start: {
          line: 272,
          column: 30
        },
        end: {
          line: 272,
          column: 90
        }
      },
      "39": {
        start: {
          line: 273,
          column: 8
        },
        end: {
          line: 279,
          column: 9
        }
      },
      "40": {
        start: {
          line: 274,
          column: 10
        },
        end: {
          line: 278,
          column: 15
        }
      },
      "41": {
        start: {
          line: 280,
          column: 8
        },
        end: {
          line: 280,
          column: 18
        }
      },
      "42": {
        start: {
          line: 287,
          column: 25
        },
        end: {
          line: 287,
          column: 85
        }
      },
      "43": {
        start: {
          line: 288,
          column: 27
        },
        end: {
          line: 288,
          column: 93
        }
      },
      "44": {
        start: {
          line: 292,
          column: 30
        },
        end: {
          line: 292,
          column: 90
        }
      },
      "45": {
        start: {
          line: 293,
          column: 8
        },
        end: {
          line: 299,
          column: 9
        }
      },
      "46": {
        start: {
          line: 294,
          column: 10
        },
        end: {
          line: 298,
          column: 13
        }
      },
      "47": {
        start: {
          line: 300,
          column: 8
        },
        end: {
          line: 300,
          column: 18
        }
      },
      "48": {
        start: {
          line: 306,
          column: 28
        },
        end: {
          line: 315,
          column: 1
        }
      },
      "49": {
        start: {
          line: 322,
          column: 4
        },
        end: {
          line: 327,
          column: 5
        }
      },
      "50": {
        start: {
          line: 323,
          column: 6
        },
        end: {
          line: 326,
          column: 8
        }
      },
      "51": {
        start: {
          line: 328,
          column: 4
        },
        end: {
          line: 328,
          column: 16
        }
      },
      "52": {
        start: {
          line: 331,
          column: 4
        },
        end: {
          line: 331,
          column: 17
        }
      },
      "53": {
        start: {
          line: 332,
          column: 4
        },
        end: {
          line: 335,
          column: 6
        }
      },
      "54": {
        start: {
          line: 343,
          column: 20
        },
        end: {
          line: 351,
          column: 3
        }
      },
      "55": {
        start: {
          line: 344,
          column: 17
        },
        end: {
          line: 344,
          column: 21
        }
      },
      "56": {
        start: {
          line: 345,
          column: 4
        },
        end: {
          line: 349,
          column: 5
        }
      },
      "57": {
        start: {
          line: 346,
          column: 6
        },
        end: {
          line: 346,
          column: 56
        }
      },
      "58": {
        start: {
          line: 348,
          column: 6
        },
        end: {
          line: 348,
          column: 84
        }
      },
      "59": {
        start: {
          line: 348,
          column: 56
        },
        end: {
          line: 348,
          column: 82
        }
      },
      "60": {
        start: {
          line: 350,
          column: 4
        },
        end: {
          line: 350,
          column: 39
        }
      },
      "61": {
        start: {
          line: 353,
          column: 21
        },
        end: {
          line: 360,
          column: 3
        }
      },
      "62": {
        start: {
          line: 354,
          column: 25
        },
        end: {
          line: 354,
          column: 50
        }
      },
      "63": {
        start: {
          line: 355,
          column: 4
        },
        end: {
          line: 357,
          column: 5
        }
      },
      "64": {
        start: {
          line: 356,
          column: 6
        },
        end: {
          line: 356,
          column: 26
        }
      },
      "65": {
        start: {
          line: 358,
          column: 4
        },
        end: {
          line: 358,
          column: 31
        }
      },
      "66": {
        start: {
          line: 359,
          column: 4
        },
        end: {
          line: 359,
          column: 26
        }
      },
      "67": {
        start: {
          line: 368,
          column: 19
        },
        end: {
          line: 374,
          column: 3
        }
      },
      "68": {
        start: {
          line: 369,
          column: 19
        },
        end: {
          line: 369,
          column: 62
        }
      },
      "69": {
        start: {
          line: 370,
          column: 4
        },
        end: {
          line: 372,
          column: 5
        }
      },
      "70": {
        start: {
          line: 371,
          column: 6
        },
        end: {
          line: 371,
          column: 18
        }
      },
      "71": {
        start: {
          line: 373,
          column: 4
        },
        end: {
          line: 373,
          column: 95
        }
      },
      "72": {
        start: {
          line: 373,
          column: 43
        },
        end: {
          line: 373,
          column: 80
        }
      },
      "73": {
        start: {
          line: 380,
          column: 17
        },
        end: {
          line: 388,
          column: 3
        }
      },
      "74": {
        start: {
          line: 381,
          column: 4
        },
        end: {
          line: 383,
          column: 5
        }
      },
      "75": {
        start: {
          line: 382,
          column: 6
        },
        end: {
          line: 382,
          column: 76
        }
      },
      "76": {
        start: {
          line: 384,
          column: 4
        },
        end: {
          line: 386,
          column: 5
        }
      },
      "77": {
        start: {
          line: 385,
          column: 6
        },
        end: {
          line: 385,
          column: 32
        }
      },
      "78": {
        start: {
          line: 387,
          column: 4
        },
        end: {
          line: 387,
          column: 64
        }
      },
      "79": {
        start: {
          line: 387,
          column: 32
        },
        end: {
          line: 387,
          column: 61
        }
      },
      "80": {
        start: {
          line: 391,
          column: 23
        },
        end: {
          line: 401,
          column: 3
        }
      },
      "81": {
        start: {
          line: 393,
          column: 4
        },
        end: {
          line: 395,
          column: 5
        }
      },
      "82": {
        start: {
          line: 394,
          column: 6
        },
        end: {
          line: 394,
          column: 13
        }
      },
      "83": {
        start: {
          line: 396,
          column: 4
        },
        end: {
          line: 400,
          column: 5
        }
      },
      "84": {
        start: {
          line: 397,
          column: 6
        },
        end: {
          line: 397,
          column: 27
        }
      },
      "85": {
        start: {
          line: 399,
          column: 6
        },
        end: {
          line: 399,
          column: 39
        }
      },
      "86": {
        start: {
          line: 404,
          column: 20
        },
        end: {
          line: 404,
          column: 57
        }
      },
      "87": {
        start: {
          line: 413,
          column: 8
        },
        end: {
          line: 413,
          column: 18
        }
      },
      "88": {
        start: {
          line: 414,
          column: 38
        },
        end: {
          line: 414,
          column: 48
        }
      },
      "89": {
        start: {
          line: 415,
          column: 25
        },
        end: {
          line: 415,
          column: 59
        }
      },
      "90": {
        start: {
          line: 416,
          column: 4
        },
        end: {
          line: 416,
          column: 82
        }
      },
      "91": {
        start: {
          line: 417,
          column: 33
        },
        end: {
          line: 417,
          column: 64
        }
      },
      "92": {
        start: {
          line: 420,
          column: 6
        },
        end: {
          line: 422,
          column: 14
        }
      },
      "93": {
        start: {
          line: 424,
          column: 4
        },
        end: {
          line: 429,
          column: 5
        }
      },
      "94": {
        start: {
          line: 426,
          column: 6
        },
        end: {
          line: 426,
          column: 73
        }
      },
      "95": {
        start: {
          line: 428,
          column: 6
        },
        end: {
          line: 428,
          column: 76
        }
      },
      "96": {
        start: {
          line: 431,
          column: 39
        },
        end: {
          line: 460,
          column: 8
        }
      },
      "97": {
        start: {
          line: 432,
          column: 6
        },
        end: {
          line: 434,
          column: 7
        }
      },
      "98": {
        start: {
          line: 433,
          column: 8
        },
        end: {
          line: 433,
          column: 20
        }
      },
      "99": {
        start: {
          line: 437,
          column: 8
        },
        end: {
          line: 448,
          column: 9
        }
      },
      "100": {
        start: {
          line: 450,
          column: 6
        },
        end: {
          line: 457,
          column: 7
        }
      },
      "101": {
        start: {
          line: 451,
          column: 8
        },
        end: {
          line: 456,
          column: 10
        }
      },
      "102": {
        start: {
          line: 459,
          column: 6
        },
        end: {
          line: 459,
          column: 32
        }
      },
      "103": {
        start: {
          line: 462,
          column: 4
        },
        end: {
          line: 504,
          column: 5
        }
      },
      "104": {
        start: {
          line: 463,
          column: 6
        },
        end: {
          line: 503,
          column: 8
        }
      },
      "105": {
        start: {
          line: 467,
          column: 12
        },
        end: {
          line: 467,
          column: 29
        }
      },
      "106": {
        start: {
          line: 484,
          column: 18
        },
        end: {
          line: 487,
          column: 26
        }
      },
      "107": {
        start: {
          line: 498,
          column: 40
        },
        end: {
          line: 498,
          column: 67
        }
      },
      "108": {
        start: {
          line: 506,
          column: 4
        },
        end: {
          line: 526,
          column: 6
        }
      },
      "109": {
        start: {
          line: 513,
          column: 10
        },
        end: {
          line: 513,
          column: 27
        }
      },
      "110": {
        start: {
          line: 520,
          column: 38
        },
        end: {
          line: 520,
          column: 65
        }
      },
      "111": {
        start: {
          line: 530,
          column: 0
        },
        end: {
          line: 579,
          column: 2
        }
      },
      "112": {
        start: {
          line: 581,
          column: 0
        },
        end: {
          line: 597,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 33,
            column: 15
          },
          end: {
            line: 33,
            column: 16
          }
        },
        loc: {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 35,
            column: 39
          }
        },
        line: 34
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 53,
            column: 10
          },
          end: {
            line: 53,
            column: 11
          }
        },
        loc: {
          start: {
            line: 53,
            column: 25
          },
          end: {
            line: 53,
            column: 54
          }
        },
        line: 53
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 65,
            column: 8
          },
          end: {
            line: 65,
            column: 9
          }
        },
        loc: {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 66,
            column: 58
          }
        },
        line: 66
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 71,
            column: 32
          },
          end: {
            line: 71,
            column: 33
          }
        },
        loc: {
          start: {
            line: 71,
            column: 48
          },
          end: {
            line: 71,
            column: 78
          }
        },
        line: 71
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 80,
            column: 9
          },
          end: {
            line: 80,
            column: 10
          }
        },
        loc: {
          start: {
            line: 80,
            column: 19
          },
          end: {
            line: 80,
            column: 49
          }
        },
        line: 80
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 90,
            column: 20
          },
          end: {
            line: 90,
            column: 21
          }
        },
        loc: {
          start: {
            line: 90,
            column: 30
          },
          end: {
            line: 90,
            column: 74
          }
        },
        line: 90
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 91,
            column: 20
          },
          end: {
            line: 91,
            column: 21
          }
        },
        loc: {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 97,
            column: 69
          }
        },
        line: 92
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 98,
            column: 24
          },
          end: {
            line: 98,
            column: 25
          }
        },
        loc: {
          start: {
            line: 99,
            column: 6
          },
          end: {
            line: 100,
            column: 37
          }
        },
        line: 99
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 111,
            column: 16
          },
          end: {
            line: 111,
            column: 17
          }
        },
        loc: {
          start: {
            line: 111,
            column: 26
          },
          end: {
            line: 111,
            column: 53
          }
        },
        line: 111
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 113,
            column: 22
          },
          end: {
            line: 113,
            column: 23
          }
        },
        loc: {
          start: {
            line: 113,
            column: 32
          },
          end: {
            line: 113,
            column: 60
          }
        },
        line: 113
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 114,
            column: 22
          },
          end: {
            line: 114,
            column: 23
          }
        },
        loc: {
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 118,
            column: 25
          }
        },
        line: 115
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 119,
            column: 29
          },
          end: {
            line: 119,
            column: 30
          }
        },
        loc: {
          start: {
            line: 120,
            column: 8
          },
          end: {
            line: 121,
            column: 39
          }
        },
        line: 120
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 140,
            column: 12
          },
          end: {
            line: 140,
            column: 13
          }
        },
        loc: {
          start: {
            line: 140,
            column: 27
          },
          end: {
            line: 140,
            column: 87
          }
        },
        line: 140
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 141,
            column: 14
          },
          end: {
            line: 141,
            column: 15
          }
        },
        loc: {
          start: {
            line: 141,
            column: 29
          },
          end: {
            line: 141,
            column: 95
          }
        },
        line: 141
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 167,
            column: 15
          },
          end: {
            line: 167,
            column: 16
          }
        },
        loc: {
          start: {
            line: 168,
            column: 8
          },
          end: {
            line: 169,
            column: 39
          }
        },
        line: 168
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 177,
            column: 10
          },
          end: {
            line: 177,
            column: 11
          }
        },
        loc: {
          start: {
            line: 178,
            column: 10
          },
          end: {
            line: 183,
            column: 11
          }
        },
        line: 178
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 196,
            column: 17
          },
          end: {
            line: 196,
            column: 18
          }
        },
        loc: {
          start: {
            line: 196,
            column: 27
          },
          end: {
            line: 196,
            column: 73
          }
        },
        line: 196
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 197,
            column: 15
          },
          end: {
            line: 197,
            column: 16
          }
        },
        loc: {
          start: {
            line: 198,
            column: 8
          },
          end: {
            line: 199,
            column: 39
          }
        },
        line: 198
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 200,
            column: 21
          },
          end: {
            line: 200,
            column: 22
          }
        },
        loc: {
          start: {
            line: 200,
            column: 31
          },
          end: {
            line: 200,
            column: 71
          }
        },
        line: 200
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 203,
            column: 19
          },
          end: {
            line: 203,
            column: 20
          }
        },
        loc: {
          start: {
            line: 204,
            column: 8
          },
          end: {
            line: 204,
            column: 90
          }
        },
        line: 204
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 205,
            column: 16
          },
          end: {
            line: 205,
            column: 17
          }
        },
        loc: {
          start: {
            line: 205,
            column: 26
          },
          end: {
            line: 205,
            column: 66
          }
        },
        line: 205
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 206,
            column: 19
          },
          end: {
            line: 206,
            column: 20
          }
        },
        loc: {
          start: {
            line: 206,
            column: 29
          },
          end: {
            line: 206,
            column: 92
          }
        },
        line: 206
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 207,
            column: 8
          },
          end: {
            line: 207,
            column: 9
          }
        },
        loc: {
          start: {
            line: 208,
            column: 8
          },
          end: {
            line: 213,
            column: 7
          }
        },
        line: 208
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 215,
            column: 8
          },
          end: {
            line: 215,
            column: 9
          }
        },
        loc: {
          start: {
            line: 216,
            column: 8
          },
          end: {
            line: 220,
            column: 9
          }
        },
        line: 216
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 224,
            column: 17
          },
          end: {
            line: 224,
            column: 18
          }
        },
        loc: {
          start: {
            line: 224,
            column: 27
          },
          end: {
            line: 224,
            column: 73
          }
        },
        line: 224
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 228,
            column: 10
          },
          end: {
            line: 228,
            column: 11
          }
        },
        loc: {
          start: {
            line: 228,
            column: 25
          },
          end: {
            line: 228,
            column: 85
          }
        },
        line: 228
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 229,
            column: 12
          },
          end: {
            line: 229,
            column: 13
          }
        },
        loc: {
          start: {
            line: 230,
            column: 12
          },
          end: {
            line: 230,
            column: 72
          }
        },
        line: 230
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 232,
            column: 8
          },
          end: {
            line: 232,
            column: 9
          }
        },
        loc: {
          start: {
            line: 233,
            column: 8
          },
          end: {
            line: 238,
            column: 7
          }
        },
        line: 233
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 240,
            column: 8
          },
          end: {
            line: 240,
            column: 9
          }
        },
        loc: {
          start: {
            line: 241,
            column: 8
          },
          end: {
            line: 245,
            column: 9
          }
        },
        line: 241
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 257,
            column: 26
          },
          end: {
            line: 257,
            column: 27
          }
        },
        loc: {
          start: {
            line: 257,
            column: 35
          },
          end: {
            line: 257,
            column: 47
          }
        },
        line: 257
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 271,
            column: 8
          },
          end: {
            line: 271,
            column: 9
          }
        },
        loc: {
          start: {
            line: 271,
            column: 17
          },
          end: {
            line: 281,
            column: 7
          }
        },
        line: 271
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 287,
            column: 10
          },
          end: {
            line: 287,
            column: 11
          }
        },
        loc: {
          start: {
            line: 287,
            column: 25
          },
          end: {
            line: 287,
            column: 85
          }
        },
        line: 287
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 288,
            column: 12
          },
          end: {
            line: 288,
            column: 13
          }
        },
        loc: {
          start: {
            line: 288,
            column: 27
          },
          end: {
            line: 288,
            column: 93
          }
        },
        line: 288
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 291,
            column: 8
          },
          end: {
            line: 291,
            column: 9
          }
        },
        loc: {
          start: {
            line: 291,
            column: 17
          },
          end: {
            line: 301,
            column: 7
          }
        },
        line: 291
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 321,
            column: 2
          },
          end: {
            line: 321,
            column: 3
          }
        },
        loc: {
          start: {
            line: 321,
            column: 52
          },
          end: {
            line: 329,
            column: 3
          }
        },
        line: 321
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 330,
            column: 2
          },
          end: {
            line: 330,
            column: 3
          }
        },
        loc: {
          start: {
            line: 330,
            column: 21
          },
          end: {
            line: 336,
            column: 3
          }
        },
        line: 330
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 343,
            column: 20
          },
          end: {
            line: 343,
            column: 21
          }
        },
        loc: {
          start: {
            line: 343,
            column: 29
          },
          end: {
            line: 351,
            column: 3
          }
        },
        line: 343
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 348,
            column: 48
          },
          end: {
            line: 348,
            column: 49
          }
        },
        loc: {
          start: {
            line: 348,
            column: 56
          },
          end: {
            line: 348,
            column: 82
          }
        },
        line: 348
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 353,
            column: 21
          },
          end: {
            line: 353,
            column: 22
          }
        },
        loc: {
          start: {
            line: 353,
            column: 45
          },
          end: {
            line: 360,
            column: 3
          }
        },
        line: 353
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 368,
            column: 19
          },
          end: {
            line: 368,
            column: 20
          }
        },
        loc: {
          start: {
            line: 368,
            column: 29
          },
          end: {
            line: 374,
            column: 3
          }
        },
        line: 368
      },
      "40": {
        name: "(anonymous_40)",
        decl: {
          start: {
            line: 373,
            column: 25
          },
          end: {
            line: 373,
            column: 26
          }
        },
        loc: {
          start: {
            line: 373,
            column: 43
          },
          end: {
            line: 373,
            column: 80
          }
        },
        line: 373
      },
      "41": {
        name: "(anonymous_41)",
        decl: {
          start: {
            line: 380,
            column: 17
          },
          end: {
            line: 380,
            column: 18
          }
        },
        loc: {
          start: {
            line: 380,
            column: 23
          },
          end: {
            line: 388,
            column: 3
          }
        },
        line: 380
      },
      "42": {
        name: "(anonymous_42)",
        decl: {
          start: {
            line: 387,
            column: 18
          },
          end: {
            line: 387,
            column: 19
          }
        },
        loc: {
          start: {
            line: 387,
            column: 32
          },
          end: {
            line: 387,
            column: 61
          }
        },
        line: 387
      },
      "43": {
        name: "(anonymous_43)",
        decl: {
          start: {
            line: 391,
            column: 23
          },
          end: {
            line: 391,
            column: 24
          }
        },
        loc: {
          start: {
            line: 391,
            column: 28
          },
          end: {
            line: 401,
            column: 3
          }
        },
        line: 391
      },
      "44": {
        name: "(anonymous_44)",
        decl: {
          start: {
            line: 403,
            column: 2
          },
          end: {
            line: 403,
            column: 3
          }
        },
        loc: {
          start: {
            line: 403,
            column: 11
          },
          end: {
            line: 527,
            column: 3
          }
        },
        line: 403
      },
      "45": {
        name: "(anonymous_45)",
        decl: {
          start: {
            line: 431,
            column: 40
          },
          end: {
            line: 431,
            column: 41
          }
        },
        loc: {
          start: {
            line: 431,
            column: 46
          },
          end: {
            line: 460,
            column: 5
          }
        },
        line: 431
      },
      "46": {
        name: "(anonymous_46)",
        decl: {
          start: {
            line: 466,
            column: 20
          },
          end: {
            line: 466,
            column: 21
          }
        },
        loc: {
          start: {
            line: 466,
            column: 28
          },
          end: {
            line: 468,
            column: 11
          }
        },
        line: 466
      },
      "47": {
        name: "(anonymous_47)",
        decl: {
          start: {
            line: 483,
            column: 45
          },
          end: {
            line: 483,
            column: 46
          }
        },
        loc: {
          start: {
            line: 484,
            column: 18
          },
          end: {
            line: 487,
            column: 26
          }
        },
        line: 484
      },
      "48": {
        name: "(anonymous_48)",
        decl: {
          start: {
            line: 498,
            column: 31
          },
          end: {
            line: 498,
            column: 32
          }
        },
        loc: {
          start: {
            line: 498,
            column: 40
          },
          end: {
            line: 498,
            column: 67
          }
        },
        line: 498
      },
      "49": {
        name: "(anonymous_49)",
        decl: {
          start: {
            line: 512,
            column: 18
          },
          end: {
            line: 512,
            column: 19
          }
        },
        loc: {
          start: {
            line: 512,
            column: 26
          },
          end: {
            line: 514,
            column: 9
          }
        },
        line: 512
      },
      "50": {
        name: "(anonymous_50)",
        decl: {
          start: {
            line: 520,
            column: 29
          },
          end: {
            line: 520,
            column: 30
          }
        },
        loc: {
          start: {
            line: 520,
            column: 38
          },
          end: {
            line: 520,
            column: 65
          }
        },
        line: 520
      },
      "51": {
        name: "(anonymous_51)",
        decl: {
          start: {
            line: 583,
            column: 19
          },
          end: {
            line: 583,
            column: 20
          }
        },
        loc: {
          start: {
            line: 583,
            column: 25
          },
          end: {
            line: 583,
            column: 27
          }
        },
        line: 583
      },
      "52": {
        name: "(anonymous_52)",
        decl: {
          start: {
            line: 592,
            column: 16
          },
          end: {
            line: 592,
            column: 17
          }
        },
        loc: {
          start: {
            line: 592,
            column: 22
          },
          end: {
            line: 592,
            column: 24
          }
        },
        line: 592
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 35,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 9
          },
          end: {
            line: 34,
            column: 27
          }
        }, {
          start: {
            line: 34,
            column: 31
          },
          end: {
            line: 34,
            column: 65
          }
        }, {
          start: {
            line: 35,
            column: 8
          },
          end: {
            line: 35,
            column: 39
          }
        }],
        line: 34
      },
      "1": {
        loc: {
          start: {
            line: 65,
            column: 18
          },
          end: {
            line: 65,
            column: 39
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 65,
            column: 37
          },
          end: {
            line: 65,
            column: 39
          }
        }],
        line: 65
      },
      "2": {
        loc: {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 66,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 66,
            column: 16
          }
        }, {
          start: {
            line: 66,
            column: 20
          },
          end: {
            line: 66,
            column: 58
          }
        }],
        line: 66
      },
      "3": {
        loc: {
          start: {
            line: 71,
            column: 48
          },
          end: {
            line: 71,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 48
          },
          end: {
            line: 71,
            column: 54
          }
        }, {
          start: {
            line: 71,
            column: 58
          },
          end: {
            line: 71,
            column: 78
          }
        }],
        line: 71
      },
      "4": {
        loc: {
          start: {
            line: 80,
            column: 19
          },
          end: {
            line: 80,
            column: 49
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 80,
            column: 34
          },
          end: {
            line: 80,
            column: 40
          }
        }, {
          start: {
            line: 80,
            column: 43
          },
          end: {
            line: 80,
            column: 49
          }
        }],
        line: 80
      },
      "5": {
        loc: {
          start: {
            line: 90,
            column: 30
          },
          end: {
            line: 90,
            column: 74
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 90,
            column: 45
          },
          end: {
            line: 90,
            column: 56
          }
        }, {
          start: {
            line: 90,
            column: 59
          },
          end: {
            line: 90,
            column: 74
          }
        }],
        line: 90
      },
      "6": {
        loc: {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 97,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 93,
            column: 10
          },
          end: {
            line: 95,
            column: 45
          }
        }, {
          start: {
            line: 96,
            column: 10
          },
          end: {
            line: 97,
            column: 69
          }
        }],
        line: 92
      },
      "7": {
        loc: {
          start: {
            line: 93,
            column: 37
          },
          end: {
            line: 95,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 93,
            column: 38
          },
          end: {
            line: 93,
            column: 63
          }
        }, {
          start: {
            line: 94,
            column: 12
          },
          end: {
            line: 94,
            column: 47
          }
        }, {
          start: {
            line: 95,
            column: 12
          },
          end: {
            line: 95,
            column: 43
          }
        }],
        line: 93
      },
      "8": {
        loc: {
          start: {
            line: 96,
            column: 13
          },
          end: {
            line: 97,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 96,
            column: 14
          },
          end: {
            line: 96,
            column: 39
          }
        }, {
          start: {
            line: 96,
            column: 43
          },
          end: {
            line: 96,
            column: 78
          }
        }, {
          start: {
            line: 97,
            column: 12
          },
          end: {
            line: 97,
            column: 43
          }
        }],
        line: 96
      },
      "9": {
        loc: {
          start: {
            line: 99,
            column: 6
          },
          end: {
            line: 100,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 99,
            column: 7
          },
          end: {
            line: 99,
            column: 32
          }
        }, {
          start: {
            line: 99,
            column: 36
          },
          end: {
            line: 99,
            column: 71
          }
        }, {
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 100,
            column: 37
          }
        }],
        line: 99
      },
      "10": {
        loc: {
          start: {
            line: 111,
            column: 26
          },
          end: {
            line: 111,
            column: 53
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 111,
            column: 41
          },
          end: {
            line: 111,
            column: 47
          }
        }, {
          start: {
            line: 111,
            column: 50
          },
          end: {
            line: 111,
            column: 53
          }
        }],
        line: 111
      },
      "11": {
        loc: {
          start: {
            line: 113,
            column: 32
          },
          end: {
            line: 113,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 113,
            column: 47
          },
          end: {
            line: 113,
            column: 52
          }
        }, {
          start: {
            line: 113,
            column: 55
          },
          end: {
            line: 113,
            column: 60
          }
        }],
        line: 113
      },
      "12": {
        loc: {
          start: {
            line: 115,
            column: 8
          },
          end: {
            line: 118,
            column: 25
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 116,
            column: 12
          },
          end: {
            line: 117,
            column: 43
          }
        }, {
          start: {
            line: 118,
            column: 12
          },
          end: {
            line: 118,
            column: 25
          }
        }],
        line: 115
      },
      "13": {
        loc: {
          start: {
            line: 116,
            column: 12
          },
          end: {
            line: 117,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 116,
            column: 13
          },
          end: {
            line: 116,
            column: 38
          }
        }, {
          start: {
            line: 116,
            column: 42
          },
          end: {
            line: 116,
            column: 83
          }
        }, {
          start: {
            line: 117,
            column: 12
          },
          end: {
            line: 117,
            column: 43
          }
        }],
        line: 116
      },
      "14": {
        loc: {
          start: {
            line: 120,
            column: 8
          },
          end: {
            line: 121,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 120,
            column: 9
          },
          end: {
            line: 120,
            column: 34
          }
        }, {
          start: {
            line: 120,
            column: 38
          },
          end: {
            line: 120,
            column: 79
          }
        }, {
          start: {
            line: 121,
            column: 8
          },
          end: {
            line: 121,
            column: 39
          }
        }],
        line: 120
      },
      "15": {
        loc: {
          start: {
            line: 140,
            column: 27
          },
          end: {
            line: 140,
            column: 87
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 140,
            column: 27
          },
          end: {
            line: 140,
            column: 45
          }
        }, {
          start: {
            line: 140,
            column: 49
          },
          end: {
            line: 140,
            column: 87
          }
        }],
        line: 140
      },
      "16": {
        loc: {
          start: {
            line: 168,
            column: 8
          },
          end: {
            line: 169,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 168,
            column: 9
          },
          end: {
            line: 168,
            column: 34
          }
        }, {
          start: {
            line: 168,
            column: 38
          },
          end: {
            line: 168,
            column: 79
          }
        }, {
          start: {
            line: 169,
            column: 8
          },
          end: {
            line: 169,
            column: 39
          }
        }],
        line: 168
      },
      "17": {
        loc: {
          start: {
            line: 178,
            column: 10
          },
          end: {
            line: 183,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 178,
            column: 10
          },
          end: {
            line: 178,
            column: 16
          }
        }, {
          start: {
            line: 179,
            column: 10
          },
          end: {
            line: 183,
            column: 11
          }
        }],
        line: 178
      },
      "18": {
        loc: {
          start: {
            line: 196,
            column: 27
          },
          end: {
            line: 196,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 196,
            column: 52
          },
          end: {
            line: 196,
            column: 63
          }
        }, {
          start: {
            line: 196,
            column: 66
          },
          end: {
            line: 196,
            column: 73
          }
        }],
        line: 196
      },
      "19": {
        loc: {
          start: {
            line: 198,
            column: 8
          },
          end: {
            line: 199,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 198,
            column: 9
          },
          end: {
            line: 198,
            column: 34
          }
        }, {
          start: {
            line: 198,
            column: 38
          },
          end: {
            line: 198,
            column: 73
          }
        }, {
          start: {
            line: 199,
            column: 8
          },
          end: {
            line: 199,
            column: 39
          }
        }],
        line: 198
      },
      "20": {
        loc: {
          start: {
            line: 200,
            column: 31
          },
          end: {
            line: 200,
            column: 71
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 200,
            column: 56
          },
          end: {
            line: 200,
            column: 62
          }
        }, {
          start: {
            line: 200,
            column: 65
          },
          end: {
            line: 200,
            column: 71
          }
        }],
        line: 200
      },
      "21": {
        loc: {
          start: {
            line: 204,
            column: 8
          },
          end: {
            line: 204,
            column: 90
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 204,
            column: 33
          },
          end: {
            line: 204,
            column: 60
          }
        }, {
          start: {
            line: 204,
            column: 63
          },
          end: {
            line: 204,
            column: 90
          }
        }],
        line: 204
      },
      "22": {
        loc: {
          start: {
            line: 205,
            column: 26
          },
          end: {
            line: 205,
            column: 66
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 205,
            column: 51
          },
          end: {
            line: 205,
            column: 57
          }
        }, {
          start: {
            line: 205,
            column: 60
          },
          end: {
            line: 205,
            column: 66
          }
        }],
        line: 205
      },
      "23": {
        loc: {
          start: {
            line: 206,
            column: 29
          },
          end: {
            line: 206,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 206,
            column: 54
          },
          end: {
            line: 206,
            column: 83
          }
        }, {
          start: {
            line: 206,
            column: 86
          },
          end: {
            line: 206,
            column: 92
          }
        }],
        line: 206
      },
      "24": {
        loc: {
          start: {
            line: 208,
            column: 8
          },
          end: {
            line: 213,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 208,
            column: 8
          },
          end: {
            line: 208,
            column: 18
          }
        }, {
          start: {
            line: 209,
            column: 8
          },
          end: {
            line: 213,
            column: 7
          }
        }],
        line: 208
      },
      "25": {
        loc: {
          start: {
            line: 215,
            column: 11
          },
          end: {
            line: 215,
            column: 33
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 215,
            column: 29
          },
          end: {
            line: 215,
            column: 33
          }
        }],
        line: 215
      },
      "26": {
        loc: {
          start: {
            line: 216,
            column: 8
          },
          end: {
            line: 220,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 216,
            column: 8
          },
          end: {
            line: 216,
            column: 16
          }
        }, {
          start: {
            line: 217,
            column: 8
          },
          end: {
            line: 217,
            column: 24
          }
        }, {
          start: {
            line: 218,
            column: 8
          },
          end: {
            line: 220,
            column: 9
          }
        }],
        line: 216
      },
      "27": {
        loc: {
          start: {
            line: 224,
            column: 27
          },
          end: {
            line: 224,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 224,
            column: 52
          },
          end: {
            line: 224,
            column: 63
          }
        }, {
          start: {
            line: 224,
            column: 66
          },
          end: {
            line: 224,
            column: 73
          }
        }],
        line: 224
      },
      "28": {
        loc: {
          start: {
            line: 228,
            column: 25
          },
          end: {
            line: 228,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 228,
            column: 25
          },
          end: {
            line: 228,
            column: 43
          }
        }, {
          start: {
            line: 228,
            column: 47
          },
          end: {
            line: 228,
            column: 85
          }
        }],
        line: 228
      },
      "29": {
        loc: {
          start: {
            line: 229,
            column: 22
          },
          end: {
            line: 229,
            column: 43
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 229,
            column: 41
          },
          end: {
            line: 229,
            column: 43
          }
        }],
        line: 229
      },
      "30": {
        loc: {
          start: {
            line: 233,
            column: 8
          },
          end: {
            line: 238,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 233,
            column: 8
          },
          end: {
            line: 233,
            column: 18
          }
        }, {
          start: {
            line: 234,
            column: 8
          },
          end: {
            line: 238,
            column: 7
          }
        }],
        line: 233
      },
      "31": {
        loc: {
          start: {
            line: 240,
            column: 11
          },
          end: {
            line: 240,
            column: 33
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 240,
            column: 29
          },
          end: {
            line: 240,
            column: 33
          }
        }],
        line: 240
      },
      "32": {
        loc: {
          start: {
            line: 241,
            column: 8
          },
          end: {
            line: 245,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 241,
            column: 8
          },
          end: {
            line: 241,
            column: 16
          }
        }, {
          start: {
            line: 242,
            column: 8
          },
          end: {
            line: 242,
            column: 24
          }
        }, {
          start: {
            line: 243,
            column: 8
          },
          end: {
            line: 245,
            column: 9
          }
        }],
        line: 241
      },
      "33": {
        loc: {
          start: {
            line: 273,
            column: 8
          },
          end: {
            line: 279,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 273,
            column: 8
          },
          end: {
            line: 279,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 273
      },
      "34": {
        loc: {
          start: {
            line: 287,
            column: 25
          },
          end: {
            line: 287,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 287,
            column: 25
          },
          end: {
            line: 287,
            column: 43
          }
        }, {
          start: {
            line: 287,
            column: 47
          },
          end: {
            line: 287,
            column: 85
          }
        }],
        line: 287
      },
      "35": {
        loc: {
          start: {
            line: 293,
            column: 8
          },
          end: {
            line: 299,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 293,
            column: 8
          },
          end: {
            line: 299,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 293
      },
      "36": {
        loc: {
          start: {
            line: 322,
            column: 4
          },
          end: {
            line: 327,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 322,
            column: 4
          },
          end: {
            line: 327,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 322
      },
      "37": {
        loc: {
          start: {
            line: 322,
            column: 8
          },
          end: {
            line: 322,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 322,
            column: 8
          },
          end: {
            line: 322,
            column: 32
          }
        }, {
          start: {
            line: 322,
            column: 36
          },
          end: {
            line: 322,
            column: 67
          }
        }],
        line: 322
      },
      "38": {
        loc: {
          start: {
            line: 325,
            column: 16
          },
          end: {
            line: 325,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 325,
            column: 49
          },
          end: {
            line: 325,
            column: 65
          }
        }, {
          start: {
            line: 325,
            column: 68
          },
          end: {
            line: 325,
            column: 80
          }
        }],
        line: 325
      },
      "39": {
        loc: {
          start: {
            line: 345,
            column: 4
          },
          end: {
            line: 349,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 345,
            column: 4
          },
          end: {
            line: 349,
            column: 5
          }
        }, {
          start: {
            line: 347,
            column: 11
          },
          end: {
            line: 349,
            column: 5
          }
        }],
        line: 345
      },
      "40": {
        loc: {
          start: {
            line: 355,
            column: 4
          },
          end: {
            line: 357,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 355,
            column: 4
          },
          end: {
            line: 357,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 355
      },
      "41": {
        loc: {
          start: {
            line: 370,
            column: 4
          },
          end: {
            line: 372,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 370,
            column: 4
          },
          end: {
            line: 372,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 370
      },
      "42": {
        loc: {
          start: {
            line: 370,
            column: 8
          },
          end: {
            line: 370,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 370,
            column: 8
          },
          end: {
            line: 370,
            column: 15
          }
        }, {
          start: {
            line: 370,
            column: 19
          },
          end: {
            line: 370,
            column: 33
          }
        }],
        line: 370
      },
      "43": {
        loc: {
          start: {
            line: 381,
            column: 4
          },
          end: {
            line: 383,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 381,
            column: 4
          },
          end: {
            line: 383,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 381
      },
      "44": {
        loc: {
          start: {
            line: 384,
            column: 4
          },
          end: {
            line: 386,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 384,
            column: 4
          },
          end: {
            line: 386,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 384
      },
      "45": {
        loc: {
          start: {
            line: 393,
            column: 4
          },
          end: {
            line: 395,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 393,
            column: 4
          },
          end: {
            line: 395,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 393
      },
      "46": {
        loc: {
          start: {
            line: 393,
            column: 8
          },
          end: {
            line: 393,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 393,
            column: 8
          },
          end: {
            line: 393,
            column: 17
          }
        }, {
          start: {
            line: 393,
            column: 21
          },
          end: {
            line: 393,
            column: 49
          }
        }],
        line: 393
      },
      "47": {
        loc: {
          start: {
            line: 396,
            column: 4
          },
          end: {
            line: 400,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 396,
            column: 4
          },
          end: {
            line: 400,
            column: 5
          }
        }, {
          start: {
            line: 398,
            column: 11
          },
          end: {
            line: 400,
            column: 5
          }
        }],
        line: 396
      },
      "48": {
        loc: {
          start: {
            line: 396,
            column: 8
          },
          end: {
            line: 396,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 396,
            column: 8
          },
          end: {
            line: 396,
            column: 26
          }
        }, {
          start: {
            line: 396,
            column: 30
          },
          end: {
            line: 396,
            column: 47
          }
        }],
        line: 396
      },
      "49": {
        loc: {
          start: {
            line: 415,
            column: 25
          },
          end: {
            line: 415,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 415,
            column: 45
          },
          end: {
            line: 415,
            column: 54
          }
        }, {
          start: {
            line: 415,
            column: 57
          },
          end: {
            line: 415,
            column: 59
          }
        }],
        line: 415
      },
      "50": {
        loc: {
          start: {
            line: 416,
            column: 21
          },
          end: {
            line: 416,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 416,
            column: 33
          },
          end: {
            line: 416,
            column: 63
          }
        }, {
          start: {
            line: 416,
            column: 67
          },
          end: {
            line: 416,
            column: 81
          }
        }],
        line: 416
      },
      "51": {
        loc: {
          start: {
            line: 420,
            column: 6
          },
          end: {
            line: 422,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 421,
            column: 10
          },
          end: {
            line: 421,
            column: 86
          }
        }, {
          start: {
            line: 422,
            column: 10
          },
          end: {
            line: 422,
            column: 14
          }
        }],
        line: 420
      },
      "52": {
        loc: {
          start: {
            line: 420,
            column: 6
          },
          end: {
            line: 420,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 420,
            column: 6
          },
          end: {
            line: 420,
            column: 13
          }
        }, {
          start: {
            line: 420,
            column: 17
          },
          end: {
            line: 420,
            column: 37
          }
        }],
        line: 420
      },
      "53": {
        loc: {
          start: {
            line: 424,
            column: 4
          },
          end: {
            line: 429,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 424,
            column: 4
          },
          end: {
            line: 429,
            column: 5
          }
        }, {
          start: {
            line: 427,
            column: 11
          },
          end: {
            line: 429,
            column: 5
          }
        }],
        line: 424
      },
      "54": {
        loc: {
          start: {
            line: 432,
            column: 6
          },
          end: {
            line: 434,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 432,
            column: 6
          },
          end: {
            line: 434,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 432
      },
      "55": {
        loc: {
          start: {
            line: 437,
            column: 8
          },
          end: {
            line: 448,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 438,
            column: 10
          },
          end: {
            line: 441,
            column: 18
          }
        }, {
          start: {
            line: 443,
            column: 10
          },
          end: {
            line: 447,
            column: 11
          }
        }],
        line: 437
      },
      "56": {
        loc: {
          start: {
            line: 437,
            column: 8
          },
          end: {
            line: 437,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 437,
            column: 8
          },
          end: {
            line: 437,
            column: 34
          }
        }, {
          start: {
            line: 437,
            column: 38
          },
          end: {
            line: 437,
            column: 64
          }
        }],
        line: 437
      },
      "57": {
        loc: {
          start: {
            line: 439,
            column: 13
          },
          end: {
            line: 439,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 439,
            column: 13
          },
          end: {
            line: 439,
            column: 38
          }
        }, {
          start: {
            line: 439,
            column: 42
          },
          end: {
            line: 439,
            column: 88
          }
        }],
        line: 439
      },
      "58": {
        loc: {
          start: {
            line: 443,
            column: 10
          },
          end: {
            line: 447,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 443,
            column: 10
          },
          end: {
            line: 443,
            column: 37
          }
        }, {
          start: {
            line: 444,
            column: 12
          },
          end: {
            line: 446,
            column: 20
          }
        }],
        line: 443
      },
      "59": {
        loc: {
          start: {
            line: 450,
            column: 6
          },
          end: {
            line: 457,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 450,
            column: 6
          },
          end: {
            line: 457,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 450
      },
      "60": {
        loc: {
          start: {
            line: 462,
            column: 4
          },
          end: {
            line: 504,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 462,
            column: 4
          },
          end: {
            line: 504,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 462
      },
      "61": {
        loc: {
          start: {
            line: 480,
            column: 11
          },
          end: {
            line: 492,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 480,
            column: 11
          },
          end: {
            line: 480,
            column: 32
          }
        }, {
          start: {
            line: 481,
            column: 12
          },
          end: {
            line: 491,
            column: 30
          }
        }],
        line: 480
      },
      "62": {
        loc: {
          start: {
            line: 482,
            column: 15
          },
          end: {
            line: 488,
            column: 18
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 482,
            column: 15
          },
          end: {
            line: 482,
            column: 23
          }
        }, {
          start: {
            line: 483,
            column: 16
          },
          end: {
            line: 488,
            column: 18
          }
        }],
        line: 482
      },
      "63": {
        loc: {
          start: {
            line: 485,
            column: 21
          },
          end: {
            line: 485,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 485,
            column: 21
          },
          end: {
            line: 485,
            column: 31
          }
        }, {
          start: {
            line: 485,
            column: 35
          },
          end: {
            line: 485,
            column: 66
          }
        }],
        line: 485
      },
      "64": {
        loc: {
          start: {
            line: 489,
            column: 15
          },
          end: {
            line: 489,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 489,
            column: 15
          },
          end: {
            line: 489,
            column: 39
          }
        }, {
          start: {
            line: 489,
            column: 43
          },
          end: {
            line: 489,
            column: 76
          }
        }],
        line: 489
      },
      "65": {
        loc: {
          start: {
            line: 490,
            column: 15
          },
          end: {
            line: 490,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 490,
            column: 15
          },
          end: {
            line: 490,
            column: 37
          }
        }, {
          start: {
            line: 490,
            column: 41
          },
          end: {
            line: 490,
            column: 73
          }
        }],
        line: 490
      },
      "66": {
        loc: {
          start: {
            line: 494,
            column: 11
          },
          end: {
            line: 501,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 494,
            column: 11
          },
          end: {
            line: 494,
            column: 28
          }
        }, {
          start: {
            line: 495,
            column: 12
          },
          end: {
            line: 500,
            column: 14
          }
        }],
        line: 494
      },
      "67": {
        loc: {
          start: {
            line: 496,
            column: 23
          },
          end: {
            line: 496,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 496,
            column: 23
          },
          end: {
            line: 496,
            column: 41
          }
        }, {
          start: {
            line: 496,
            column: 45
          },
          end: {
            line: 496,
            column: 52
          }
        }],
        line: 496
      },
      "68": {
        loc: {
          start: {
            line: 516,
            column: 9
          },
          end: {
            line: 524,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 516,
            column: 9
          },
          end: {
            line: 516,
            column: 26
          }
        }, {
          start: {
            line: 517,
            column: 10
          },
          end: {
            line: 523,
            column: 12
          }
        }],
        line: 516
      },
      "69": {
        loc: {
          start: {
            line: 518,
            column: 21
          },
          end: {
            line: 518,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 518,
            column: 21
          },
          end: {
            line: 518,
            column: 39
          }
        }, {
          start: {
            line: 518,
            column: 43
          },
          end: {
            line: 518,
            column: 50
          }
        }],
        line: 518
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0],
      "8": [0, 0, 0],
      "9": [0, 0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0, 0],
      "14": [0, 0, 0],
      "15": [0, 0],
      "16": [0, 0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0],
      "26": [0, 0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0],
      "30": [0, 0],
      "31": [0],
      "32": [0, 0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0],
      "64": [0, 0],
      "65": [0, 0],
      "66": [0, 0],
      "67": [0, 0],
      "68": [0, 0],
      "69": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a337dec0c2513299158c1139c0880a5858aa5fb8"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_21ccn4jg1n = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_21ccn4jg1n();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Wrapper = (cov_21ccn4jg1n().s[0]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-MultiDropDown"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n      float: left;\n      position: relative;\n      display: table;\n      color: ", ";\n      &:hover {\n        cursor: pointer;\n      }\n    "])), function (props) {
  cov_21ccn4jg1n().f[0]++;
  cov_21ccn4jg1n().s[1]++;
  return (cov_21ccn4jg1n().b[0][0]++, props.theme.button) && (cov_21ccn4jg1n().b[0][1]++, props.theme.button.backgroundColor) || (cov_21ccn4jg1n().b[0][2]++, _stylingConstants.default.color.baseText);
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n      float: left;\n      position: relative;\n      ", ";\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      color: ", ";\n      font-weight: ", ";\n      font-size: ", ";\n      line-height: ", ";\n\n      :has(.g-DropDown-Container) {\n        ", ";\n      }\n      &:hover {\n        cursor: pointer;\n      }\n    "])), _utils.inputMixin, _themeMapper.evolutionTheme.multiDropdown.color, _themeMapper.evolutionTheme.multiDropdown.fontWeight, _themeMapper.evolutionTheme.multiDropdown.fontSize, _themeMapper.evolutionTheme.multiDropdown.lineHeight, function (_ref) {
  var theme = _ref.theme;
  cov_21ccn4jg1n().f[1]++;
  cov_21ccn4jg1n().s[2]++;
  return (0, _utils.boxShadow)(theme.primaryColor);
}))));
var SelectorIcon = (cov_21ccn4jg1n().s[3]++, (0, _styledComponents.default)(_icon.default).attrs({
  className: 'g-MultiDropDown-SelectorIcon',
  iconName: 'riArrowDownSLine',
  size: function size(_ref2) {
    var _ref2$theme = _ref2.theme,
      _ref2$theme2 = _ref2$theme === void 0 ? (cov_21ccn4jg1n().b[1][0]++, {}) : _ref2$theme,
      iconFontSize = _ref2$theme2.iconFontSize;
    cov_21ccn4jg1n().f[2]++;
    cov_21ccn4jg1n().s[4]++;
    return (cov_21ccn4jg1n().b[2][0]++, iconFontSize) || (cov_21ccn4jg1n().b[2][1]++, _themeMapper.evolutionTheme.multiDropdown.icon.size);
  }
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  right: ", ";\n  top: 50%;\n  transform: translateY(-50%) ", ";\n  transition: transform 0.5s ease-in-out;\n"])), _themeMapper.evolutionTheme.multiDropdown.paddingX, function (_ref3) {
  var isOpen = _ref3.isOpen;
  cov_21ccn4jg1n().f[3]++;
  cov_21ccn4jg1n().s[5]++;
  return (cov_21ccn4jg1n().b[3][0]++, isOpen) && (cov_21ccn4jg1n().b[3][1]++, (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["rotate(0.5turn)"]))));
}));
var ArrowSelector = (cov_21ccn4jg1n().s[6]++, _styledComponents.default.i.attrs({
  className: 'g-MultiDropDown-ArrowSelector'
})(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n  width: 18px;\n  position: absolute;\n  top: ", ";\n  right: 2px;\n  text-align: center;\n  &:after {\n    content: '';\n    border-style: solid;\n    display: inline-block;\n    height: 0;\n    width: 0;\n    position: relative;\n    border-width: ", ";\n    border-color: ", ";\n    border-top-color: ", ";\n  }\n"])), function (props) {
  cov_21ccn4jg1n().f[4]++;
  cov_21ccn4jg1n().s[7]++;
  return props.isOpen ? (cov_21ccn4jg1n().b[4][0]++, '24px') : (cov_21ccn4jg1n().b[4][1]++, '27px');
}, function (props) {
  cov_21ccn4jg1n().f[5]++;
  cov_21ccn4jg1n().s[8]++;
  return props.isOpen ? (cov_21ccn4jg1n().b[5][0]++, '0 5px 5px') : (cov_21ccn4jg1n().b[5][1]++, '5px 5px 2.5px');
}, function (props) {
  cov_21ccn4jg1n().f[6]++;
  cov_21ccn4jg1n().s[9]++;
  return props.isOpen ? (cov_21ccn4jg1n().b[6][0]++, "transparent transparent ".concat((cov_21ccn4jg1n().b[7][0]++, props.theme.multiDropdown) && (cov_21ccn4jg1n().b[7][1]++, props.theme.multiDropdown.colorText) || (cov_21ccn4jg1n().b[7][2]++, _stylingConstants.default.color.baseText))) : (cov_21ccn4jg1n().b[6][1]++, "".concat((cov_21ccn4jg1n().b[8][0]++, props.theme.multiDropdown) && (cov_21ccn4jg1n().b[8][1]++, props.theme.multiDropdown.colorText) || (cov_21ccn4jg1n().b[8][2]++, _stylingConstants.default.color.baseText), " transparent transparent"));
}, function (props) {
  cov_21ccn4jg1n().f[7]++;
  cov_21ccn4jg1n().s[10]++;
  return (cov_21ccn4jg1n().b[9][0]++, props.theme.multiDropdown) && (cov_21ccn4jg1n().b[9][1]++, props.theme.multiDropdown.colorText) || (cov_21ccn4jg1n().b[9][2]++, _stylingConstants.default.color.baseText);
}));
var SelectContainer = (cov_21ccn4jg1n().s[11]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-MultiDropDown-Container"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n      display: flex;\n      height: ", ";\n      padding-right: 17px;\n      border-width: ", ";\n      border-color: ", ";\n      border-bottom-color: ", ";\n      border-style: solid;\n      span.g-MultiDropDown-Input {\n        ::after {\n          content: ',';\n          display: table-cell;\n        }\n\n        :last-of-type {\n          ::after {\n            content: '';\n          }\n        }\n      }\n    "])), function (props) {
  cov_21ccn4jg1n().f[8]++;
  cov_21ccn4jg1n().s[12]++;
  return props.filled ? (cov_21ccn4jg1n().b[10][0]++, '34px') : (cov_21ccn4jg1n().b[10][1]++, '0');
}, function (props) {
  cov_21ccn4jg1n().f[9]++;
  cov_21ccn4jg1n().s[13]++;
  return props.filled ? (cov_21ccn4jg1n().b[11][0]++, '2px') : (cov_21ccn4jg1n().b[11][1]++, '1px');
}, function (props) {
  cov_21ccn4jg1n().f[10]++;
  cov_21ccn4jg1n().s[14]++;
  return props.filled ? (cov_21ccn4jg1n().b[12][0]++, (cov_21ccn4jg1n().b[13][0]++, props.theme.multiDropdown) && (cov_21ccn4jg1n().b[13][1]++, props.theme.multiDropdown.backgroundColor) || (cov_21ccn4jg1n().b[13][2]++, _stylingConstants.default.color.baseText)) : (cov_21ccn4jg1n().b[12][1]++, 'transparent');
}, function (props) {
  cov_21ccn4jg1n().f[11]++;
  cov_21ccn4jg1n().s[15]++;
  return (cov_21ccn4jg1n().b[14][0]++, props.theme.multiDropdown) && (cov_21ccn4jg1n().b[14][1]++, props.theme.multiDropdown.backgroundColor) || (cov_21ccn4jg1n().b[14][2]++, _stylingConstants.default.color.baseText);
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n      > .g-MultiDropDown-Input {\n        // Space for icon size + spacing with it\n        padding-right: calc(\n          ", " +\n            ", "\n        );\n      }\n      span.g-MultiDropDown-Input {\n        ::after {\n          content: ',';\n          display: table-cell;\n        }\n\n        :last-of-type {\n          ::after {\n            content: '';\n          }\n        }\n      }\n    "])), function (_ref4) {
  var theme = _ref4.theme;
  cov_21ccn4jg1n().f[12]++;
  cov_21ccn4jg1n().s[16]++;
  return (cov_21ccn4jg1n().b[15][0]++, theme.iconFontSize) || (cov_21ccn4jg1n().b[15][1]++, _themeMapper.evolutionTheme.multiDropdown.icon.size);
}, function (_ref5) {
  var theme = _ref5.theme;
  cov_21ccn4jg1n().f[13]++;
  cov_21ccn4jg1n().s[17]++;
  return (0, _utils.getPadding)(theme.inputPadding, _themeMapper.evolutionTheme.input.padding).right;
}))));
var Input = (cov_21ccn4jg1n().s[18]++, (0, _utils.withThemedStyles)(_styledComponents.default.span.attrs({
  className: "g-MultiDropDown-Input",
  isLast: true
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n      color: ", ";\n      display: flex;\n      align-items: center;\n      line-height: 34px;\n      padding: 0 5px;\n    "])), function (props) {
  cov_21ccn4jg1n().f[14]++;
  cov_21ccn4jg1n().s[19]++;
  return (cov_21ccn4jg1n().b[16][0]++, props.theme.multiDropdown) && (cov_21ccn4jg1n().b[16][1]++, props.theme.multiDropdown.backgroundColor) || (cov_21ccn4jg1n().b[16][2]++, _stylingConstants.default.color.baseText);
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n      &.g-MultiDropDown-Input {\n        ", ";\n      }\n    "])), function (_ref6) {
  var isLast = _ref6.isLast;
  cov_21ccn4jg1n().f[15]++;
  cov_21ccn4jg1n().s[20]++;
  return (cov_21ccn4jg1n().b[17][0]++, isLast) && (cov_21ccn4jg1n().b[17][1]++, (0, _styledComponents.css)(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n            ::after {\n              content: '' !important;\n            }\n          "]))));
}))));
var Placeholder = (cov_21ccn4jg1n().s[21]++, (0, _utils.withThemedStyles)(_styledComponents.default.div.attrs({
  className: "g-MultiDropDown-Placeholder"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n      width: 100%;\n      display: ", ";\n      color: ", ";\n      line-height: ", ";\n      padding-top: 17px;\n      padding-right: 20px;\n      font-size: ", ";\n      height: ", ";\n      transform: ", ";\n      ", ";\n\n      ", ";\n    "])), function (props) {
  cov_21ccn4jg1n().f[16]++;
  cov_21ccn4jg1n().s[22]++;
  return props.title === 'true' ? (cov_21ccn4jg1n().b[18][0]++, 'table-row') : (cov_21ccn4jg1n().b[18][1]++, 'block');
}, function (props) {
  cov_21ccn4jg1n().f[17]++;
  cov_21ccn4jg1n().s[23]++;
  return (cov_21ccn4jg1n().b[19][0]++, props.theme.multiDropdown) && (cov_21ccn4jg1n().b[19][1]++, props.theme.multiDropdown.colorText) || (cov_21ccn4jg1n().b[19][2]++, _stylingConstants.default.color.baseText);
}, function (props) {
  cov_21ccn4jg1n().f[18]++;
  cov_21ccn4jg1n().s[24]++;
  return props.title === 'true' ? (cov_21ccn4jg1n().b[20][0]++, '17px') : (cov_21ccn4jg1n().b[20][1]++, '34px');
}, function (props) {
  cov_21ccn4jg1n().f[19]++;
  cov_21ccn4jg1n().s[25]++;
  return props.title === 'true' ? (cov_21ccn4jg1n().b[21][0]++, _stylingConstants.default.font.sizeS) : (cov_21ccn4jg1n().b[21][1]++, _stylingConstants.default.font.sizeM);
}, function (props) {
  cov_21ccn4jg1n().f[20]++;
  cov_21ccn4jg1n().s[26]++;
  return props.title === 'true' ? (cov_21ccn4jg1n().b[22][0]++, '17px') : (cov_21ccn4jg1n().b[22][1]++, '34px');
}, function (props) {
  cov_21ccn4jg1n().f[21]++;
  cov_21ccn4jg1n().s[27]++;
  return props.title === 'true' ? (cov_21ccn4jg1n().b[23][0]++, 'translateX(-8px) scale(.75)') : (cov_21ccn4jg1n().b[23][1]++, 'none');
}, function (props) {
  cov_21ccn4jg1n().f[22]++;
  cov_21ccn4jg1n().s[28]++;
  return (cov_21ccn4jg1n().b[24][0]++, props.icon) && (cov_21ccn4jg1n().b[24][1]++, "\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      ");
}, function (_ref7) {
  var _ref7$keepPlaceholder = _ref7.keepPlaceholder,
    keepPlaceholder = _ref7$keepPlaceholder === void 0 ? (cov_21ccn4jg1n().b[25][0]++, true) : _ref7$keepPlaceholder,
    noValue = _ref7.noValue;
  cov_21ccn4jg1n().f[23]++;
  cov_21ccn4jg1n().s[29]++;
  return (cov_21ccn4jg1n().b[26][0]++, !noValue) && (cov_21ccn4jg1n().b[26][1]++, !keepPlaceholder) && (cov_21ccn4jg1n().b[26][2]++, (0, _styledComponents.css)(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n          display: none;\n        "]))));
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n      width: 100%;\n      display: ", ";\n      box-sizing: border-box;\n      // Space for icon size + spacing with it\n      padding-right: calc(\n        ", " +\n          ", "\n      );\n      ", ";\n\n      ", ";\n    "])), function (props) {
  cov_21ccn4jg1n().f[24]++;
  cov_21ccn4jg1n().s[30]++;
  return props.title === 'true' ? (cov_21ccn4jg1n().b[27][0]++, 'table-row') : (cov_21ccn4jg1n().b[27][1]++, 'block');
}, function (_ref8) {
  var theme = _ref8.theme;
  cov_21ccn4jg1n().f[25]++;
  cov_21ccn4jg1n().s[31]++;
  return (cov_21ccn4jg1n().b[28][0]++, theme.iconFontSize) || (cov_21ccn4jg1n().b[28][1]++, _themeMapper.evolutionTheme.multiDropdown.icon.size);
}, function (_ref9) {
  var _ref9$theme = _ref9.theme,
    _ref9$theme2 = _ref9$theme === void 0 ? (cov_21ccn4jg1n().b[29][0]++, {}) : _ref9$theme,
    inputPadding = _ref9$theme2.inputPadding;
  cov_21ccn4jg1n().f[26]++;
  cov_21ccn4jg1n().s[32]++;
  return (0, _utils.getPadding)(inputPadding, _themeMapper.evolutionTheme.input.padding).right;
}, function (props) {
  cov_21ccn4jg1n().f[27]++;
  cov_21ccn4jg1n().s[33]++;
  return (cov_21ccn4jg1n().b[30][0]++, props.icon) && (cov_21ccn4jg1n().b[30][1]++, "\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      ");
}, function (_ref10) {
  var _ref10$keepPlaceholde = _ref10.keepPlaceholder,
    keepPlaceholder = _ref10$keepPlaceholde === void 0 ? (cov_21ccn4jg1n().b[31][0]++, true) : _ref10$keepPlaceholde,
    noValue = _ref10.noValue;
  cov_21ccn4jg1n().f[28]++;
  cov_21ccn4jg1n().s[34]++;
  return (cov_21ccn4jg1n().b[32][0]++, !noValue) && (cov_21ccn4jg1n().b[32][1]++, !keepPlaceholder) && (cov_21ccn4jg1n().b[32][2]++, (0, _styledComponents.css)(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n          display: none;\n        "]))));
}))));
var Picture = (cov_21ccn4jg1n().s[35]++, _styledComponents.default.i(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  display: table-cell;\n  vertical-align: middle;\n  width: 20px;\n  height: 20px;\n  margin-right: 5px;\n  background-image: url(", ");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n"])), function (props) {
  cov_21ccn4jg1n().f[29]++;
  cov_21ccn4jg1n().s[36]++;
  return props.source;
}));
var Label = (cov_21ccn4jg1n().s[37]++, (0, _utils.withThemedStyles)(_styledComponents.default.span.attrs({
  className: "g-MultiDropDown-Label"
}), (0, _defineProperty2.default)((0, _defineProperty2.default)({}, _themeProvider.TicketShopTheme.EQUILIBRIUM, (0, _styledComponents.css)(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2.default)(["\n      position: relative;\n      display: table-cell;\n      padding-left: 5px;\n      ", ";\n    "])), function (props) {
  cov_21ccn4jg1n().f[30]++;
  var tableMinWidth = (cov_21ccn4jg1n().s[38]++, (0, _get.default)(props, 'theme.multiDropdown.mediaQueries.tablet', false));
  cov_21ccn4jg1n().s[39]++;
  if (tableMinWidth) {
    cov_21ccn4jg1n().b[33][0]++;
    cov_21ccn4jg1n().s[40]++;
    return "@media (min-width: ".concat(tableMinWidth, ") {\n              white-space: nowrap;\n              overflow: hidden;\n              text-overflow: ellipsis;\n            }");
  } else {
    cov_21ccn4jg1n().b[33][1]++;
  }
  cov_21ccn4jg1n().s[41]++;
  return '';
})), _themeProvider.TicketShopTheme.EVOLUTION, (0, _styledComponents.css)(_templateObject17 || (_templateObject17 = (0, _taggedTemplateLiteral2.default)(["\n      position: relative;\n      display: table-cell;\n      padding-right: calc(\n        ", " +\n          ", "\n      );\n      color: ", ";\n      ", ";\n    "])), function (_ref11) {
  var theme = _ref11.theme;
  cov_21ccn4jg1n().f[31]++;
  cov_21ccn4jg1n().s[42]++;
  return (cov_21ccn4jg1n().b[34][0]++, theme.iconFontSize) || (cov_21ccn4jg1n().b[34][1]++, _themeMapper.evolutionTheme.multiDropdown.icon.size);
}, function (_ref12) {
  var theme = _ref12.theme;
  cov_21ccn4jg1n().f[32]++;
  cov_21ccn4jg1n().s[43]++;
  return (0, _utils.getPadding)(theme.inputPadding, _themeMapper.evolutionTheme.input.padding).right;
}, _themeMapper.evolutionTheme.multiDropdown.color, function (props) {
  cov_21ccn4jg1n().f[33]++;
  var tableMinWidth = (cov_21ccn4jg1n().s[44]++, (0, _get.default)(props, 'theme.multiDropdown.mediaQueries.tablet', false));
  cov_21ccn4jg1n().s[45]++;
  if (tableMinWidth) {
    cov_21ccn4jg1n().b[35][0]++;
    cov_21ccn4jg1n().s[46]++;
    return "@media (min-width: ".concat(tableMinWidth, ") {\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }");
  } else {
    cov_21ccn4jg1n().b[35][1]++;
  }
  cov_21ccn4jg1n().s[47]++;
  return '';
}))));
var IconDropdownWrapper = (cov_21ccn4jg1n().s[48]++, _styledComponents.default.div.attrs({
  className: 'g-IconDropdown-Wrapper'
})(_templateObject18 || (_templateObject18 = (0, _taggedTemplateLiteral2.default)(["\n  width: auto;\n  height: auto;\n  position: absolute;\n  display: flex;\n  right: 1px;\n  top: 7px;\n"]))));

/**
 * Component to draw a Multiple Selector values
 */
var MultiDropDown = /*#__PURE__*/function (_Component) {
  function MultiDropDown(props) {
    var _this;
    (0, _classCallCheck2.default)(this, MultiDropDown);
    cov_21ccn4jg1n().f[35]++;
    cov_21ccn4jg1n().s[52]++;
    _this = _callSuper(this, MultiDropDown, [props]);
    /**
     * Method called when an option has been clicked. Adds value to those previously selected.
     * Check if the value has been inserted already or not.
     * @param {object} value, content of option
     */
    (0, _defineProperty2.default)(_this, "onSelectedValue", (cov_21ccn4jg1n().s[54]++, function (value) {
      cov_21ccn4jg1n().f[36]++;
      var values = (cov_21ccn4jg1n().s[55]++, null);
      cov_21ccn4jg1n().s[56]++;
      if (_this.isOptionUnique(value)) {
        cov_21ccn4jg1n().b[39][0]++;
        cov_21ccn4jg1n().s[57]++;
        values = _this.addValueSelected(value, _this.state);
      } else {
        cov_21ccn4jg1n().b[39][1]++;
        cov_21ccn4jg1n().s[58]++;
        values = (0, _reject.default)(_this.state.selectedItems, function (item) {
          cov_21ccn4jg1n().f[37]++;
          cov_21ccn4jg1n().s[59]++;
          return item.value === value.value;
        });
      }
      cov_21ccn4jg1n().s[60]++;
      _this.props.onSelectedValue(values);
    }));
    (0, _defineProperty2.default)(_this, "addValueSelected", (cov_21ccn4jg1n().s[61]++, function (value, valuesAdded) {
      cov_21ccn4jg1n().f[38]++;
      var previousValues = (cov_21ccn4jg1n().s[62]++, valuesAdded.selectedItems);
      cov_21ccn4jg1n().s[63]++;
      if (_this.props.single) {
        cov_21ccn4jg1n().b[40][0]++;
        cov_21ccn4jg1n().s[64]++;
        previousValues = [];
      } else {
        cov_21ccn4jg1n().b[40][1]++;
      }
      cov_21ccn4jg1n().s[65]++;
      previousValues.push(value);
      cov_21ccn4jg1n().s[66]++;
      return previousValues;
    }));
    /**
     * Check if the value has been inserted.
     * @param {object} option, value to insert
     *
     * @return {Boolean} true, if the value is not part of the collection
     */
    (0, _defineProperty2.default)(_this, "isOptionUnique", (cov_21ccn4jg1n().s[67]++, function (option) {
      cov_21ccn4jg1n().f[39]++;
      var values = (cov_21ccn4jg1n().s[68]++, (0, _assign.default)([], _this.state.selectedItems));
      cov_21ccn4jg1n().s[69]++;
      if ((cov_21ccn4jg1n().b[42][0]++, !values) || (cov_21ccn4jg1n().b[42][1]++, !values.length)) {
        cov_21ccn4jg1n().b[41][0]++;
        cov_21ccn4jg1n().s[70]++;
        return true;
      } else {
        cov_21ccn4jg1n().b[41][1]++;
      }
      cov_21ccn4jg1n().s[71]++;
      return values.filter(function (existingOption) {
        cov_21ccn4jg1n().f[40]++;
        cov_21ccn4jg1n().s[72]++;
        return existingOption.value === option.value;
      }).length === 0;
    }));
    /**
     * Method called when selector component has been clicked
     * Creates a listener to close the dropdown when click outside
     */
    (0, _defineProperty2.default)(_this, "toggleSelect", (cov_21ccn4jg1n().s[73]++, function () {
      cov_21ccn4jg1n().f[41]++;
      cov_21ccn4jg1n().s[74]++;
      if (!_this.state.isOpen) {
        cov_21ccn4jg1n().b[43][0]++;
        cov_21ccn4jg1n().s[75]++;
        document.removeEventListener('click', _this.handleOutsideClick, false);
      } else {
        cov_21ccn4jg1n().b[43][1]++;
      }
      cov_21ccn4jg1n().s[76]++;
      if (_this.props.toggleSelect) {
        cov_21ccn4jg1n().b[44][0]++;
        cov_21ccn4jg1n().s[77]++;
        _this.props.toggleSelect();
      } else {
        cov_21ccn4jg1n().b[44][1]++;
      }
      cov_21ccn4jg1n().s[78]++;
      _this.setState(function (prevState) {
        cov_21ccn4jg1n().f[42]++;
        cov_21ccn4jg1n().s[79]++;
        return {
          isOpen: !prevState.isOpen
        };
      });
    }));
    /** Method to close the pop up when the user clicks out of the component */
    (0, _defineProperty2.default)(_this, "handleOutsideClick", (cov_21ccn4jg1n().s[80]++, function (e) {
      cov_21ccn4jg1n().f[43]++;
      cov_21ccn4jg1n().s[81]++;
      // ignore clicks on the component itself
      if ((cov_21ccn4jg1n().b[46][0]++, _this.node) && (cov_21ccn4jg1n().b[46][1]++, _this.node.contains(e.target))) {
        cov_21ccn4jg1n().b[45][0]++;
        cov_21ccn4jg1n().s[82]++;
        return;
      } else {
        cov_21ccn4jg1n().b[45][1]++;
      }
      cov_21ccn4jg1n().s[83]++;
      if ((cov_21ccn4jg1n().b[48][0]++, _this.props.onClose) && (cov_21ccn4jg1n().b[48][1]++, _this.state.isOpen)) {
        cov_21ccn4jg1n().b[47][0]++;
        cov_21ccn4jg1n().s[84]++;
        _this.props.onClose();
      } else {
        cov_21ccn4jg1n().b[47][1]++;
        cov_21ccn4jg1n().s[85]++;
        _this.setState({
          isOpen: false
        });
      }
    }));
    cov_21ccn4jg1n().s[53]++;
    _this.state = {
      isOpen: props.isOpen,
      selectedItems: []
    };
    return _this;
  }
  (0, _inherits2.default)(MultiDropDown, _Component);
  return (0, _createClass2.default)(MultiDropDown, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      cov_21ccn4jg1n().f[44]++;
      var noValue = (cov_21ccn4jg1n().s[86]++, this.state.selectedItems.length === 0);
      var _ref13 = (cov_21ccn4jg1n().s[87]++, this.props),
        options = _ref13.options,
        single = _ref13.single,
        leftIcon = _ref13.leftIcon,
        IconDropdown = _ref13.IconDropdown,
        message = _ref13.message,
        keepPlaceholder = _ref13.keepPlaceholder,
        themeQueries = _ref13.themeQueries;
      var _ref14 = (cov_21ccn4jg1n().s[88]++, this.state),
        selectedItems = _ref14.selectedItems,
        isOpen = _ref14.isOpen;
      var componentClass = (cov_21ccn4jg1n().s[89]++, this.state.isOpen ? (cov_21ccn4jg1n().b[49][0]++, 'is-open') : (cov_21ccn4jg1n().b[49][1]++, ''));
      cov_21ccn4jg1n().s[90]++;
      componentClass = !noValue ? (cov_21ccn4jg1n().b[50][0]++, componentClass += ' is-filled') : (cov_21ccn4jg1n().b[50][1]++, componentClass);
      var customSelectedValues = (cov_21ccn4jg1n().s[91]++, this.props.customSelectedValues);
      var noOptionsAvailable = (cov_21ccn4jg1n().s[92]++, (cov_21ccn4jg1n().b[52][0]++, options) && (cov_21ccn4jg1n().b[52][1]++, options.length === 0) ? (cov_21ccn4jg1n().b[51][0]++, [{
        label: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: "gravity.MultiDropdown.noOptions",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 421,
            columnNumber: 21
          }
        })
      }]) : (cov_21ccn4jg1n().b[51][1]++, null));
      cov_21ccn4jg1n().s[93]++;
      if (this.state.isOpen) {
        cov_21ccn4jg1n().b[53][0]++;
        cov_21ccn4jg1n().s[94]++;
        // attach/remove event handler
        document.addEventListener('click', this.handleOutsideClick, false);
      } else {
        cov_21ccn4jg1n().b[53][1]++;
        cov_21ccn4jg1n().s[95]++;
        document.removeEventListener('click', this.handleOutsideClick, false);
      }
      var customSelectedValueElement = (cov_21ccn4jg1n().s[96]++, function () {
        cov_21ccn4jg1n().f[45]++;
        cov_21ccn4jg1n().s[97]++;
        if (!customSelectedValues) {
          cov_21ccn4jg1n().b[54][0]++;
          cov_21ccn4jg1n().s[98]++;
          return null;
        } else {
          cov_21ccn4jg1n().b[54][1]++;
        }
        var customValueElement = (cov_21ccn4jg1n().s[99]++, (cov_21ccn4jg1n().b[56][0]++, customSelectedValues.value) && (cov_21ccn4jg1n().b[56][1]++, customSelectedValues.label) ? (cov_21ccn4jg1n().b[55][0]++, /*#__PURE__*/_react.default.createElement(Input, {
          key: customSelectedValues.value,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 438,
            columnNumber: 11
          }
        }, (cov_21ccn4jg1n().b[57][0]++, customSelectedValues.icon) && (cov_21ccn4jg1n().b[57][1]++, /*#__PURE__*/_react.default.createElement(Picture, {
          source: customSelectedValues.icon,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 439,
            columnNumber: 43
          }
        })), /*#__PURE__*/_react.default.createElement(Label, {
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 440,
            columnNumber: 13
          }
        }, customSelectedValues.label))) : (cov_21ccn4jg1n().b[55][1]++, (cov_21ccn4jg1n().b[58][0]++, !customSelectedValues.value) && (cov_21ccn4jg1n().b[58][1]++, /*#__PURE__*/_react.default.createElement(Input, {
          key: customSelectedValues,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 444,
            columnNumber: 13
          }
        }, /*#__PURE__*/_react.default.createElement(Label, {
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 445,
            columnNumber: 15
          }
        }, customSelectedValues)))));
        cov_21ccn4jg1n().s[100]++;
        if (themeQueries.EVOLUTION) {
          cov_21ccn4jg1n().b[59][0]++;
          cov_21ccn4jg1n().s[101]++;
          return /*#__PURE__*/_react.default.createElement(SelectContainer, {
            filled: !noValue,
            isCustom: true,
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 452,
              columnNumber: 11
            }
          }, customValueElement, /*#__PURE__*/_react.default.createElement(SelectorIcon, {
            isOpen: isOpen,
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 454,
              columnNumber: 13
            }
          }));
        } else {
          cov_21ccn4jg1n().b[59][1]++;
        }
        cov_21ccn4jg1n().s[102]++;
        return customValueElement;
      }());
      cov_21ccn4jg1n().s[103]++;
      if (!IconDropdown) {
        cov_21ccn4jg1n().b[60][0]++;
        cov_21ccn4jg1n().s[104]++;
        return /*#__PURE__*/_react.default.createElement(Wrapper, {
          onClick: this.toggleSelect,
          innerRef: function innerRef(node) {
            cov_21ccn4jg1n().f[46]++;
            cov_21ccn4jg1n().s[105]++;
            _this2.node = node;
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 464,
            columnNumber: 9
          }
        }, leftIcon, /*#__PURE__*/_react.default.createElement(Placeholder, {
          className: componentClass,
          noValue: noValue,
          keepPlaceholder: keepPlaceholder,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 471,
            columnNumber: 11
          }
        }, this.props.placeholder), customSelectedValueElement, (cov_21ccn4jg1n().b[61][0]++, !customSelectedValues) && (cov_21ccn4jg1n().b[61][1]++, /*#__PURE__*/_react.default.createElement(SelectContainer, {
          filled: !noValue,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 481,
            columnNumber: 13
          }
        }, (cov_21ccn4jg1n().b[62][0]++, !noValue) && (cov_21ccn4jg1n().b[62][1]++, this.state.selectedItems.map(function (value, index) {
          cov_21ccn4jg1n().f[47]++;
          cov_21ccn4jg1n().s[106]++;
          return /*#__PURE__*/_react.default.createElement(Input, {
            key: value.value,
            isLast: index === _this2.state.selectedItems.length - 1,
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 484,
              columnNumber: 19
            }
          }, (cov_21ccn4jg1n().b[63][0]++, value.icon) && (cov_21ccn4jg1n().b[63][1]++, /*#__PURE__*/_react.default.createElement(Picture, {
            source: value.icon,
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 485,
              columnNumber: 36
            }
          })), /*#__PURE__*/_react.default.createElement(Label, {
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 486,
              columnNumber: 21
            }
          }, value.label));
        })), (cov_21ccn4jg1n().b[64][0]++, themeQueries.EQUILIBRIUM) && (cov_21ccn4jg1n().b[64][1]++, /*#__PURE__*/_react.default.createElement(ArrowSelector, {
          isOpen: isOpen,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 489,
            columnNumber: 44
          }
        })), (cov_21ccn4jg1n().b[65][0]++, themeQueries.EVOLUTION) && (cov_21ccn4jg1n().b[65][1]++, /*#__PURE__*/_react.default.createElement(SelectorIcon, {
          isOpen: isOpen,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 490,
            columnNumber: 42
          }
        })))), (cov_21ccn4jg1n().b[66][0]++, this.state.isOpen) && (cov_21ccn4jg1n().b[66][1]++, /*#__PURE__*/_react.default.createElement(_DropDown.default, {
          options: (cov_21ccn4jg1n().b[67][0]++, noOptionsAvailable) || (cov_21ccn4jg1n().b[67][1]++, options),
          selectedItems: selectedItems,
          onSelectedValue: function onSelectedValue(value) {
            cov_21ccn4jg1n().f[48]++;
            cov_21ccn4jg1n().s[107]++;
            return _this2.onSelectedValue(value);
          },
          single: single,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 495,
            columnNumber: 13
          }
        })));
      } else {
        cov_21ccn4jg1n().b[60][1]++;
      }
      cov_21ccn4jg1n().s[108]++;
      return /*#__PURE__*/_react.default.createElement(IconDropdownWrapper, {
        "data-intro": message.saleHistoryView,
        "data-sequence": '7',
        "data-position": "bottom",
        onClick: this.toggleSelect,
        innerRef: function innerRef(node) {
          cov_21ccn4jg1n().f[49]++;
          cov_21ccn4jg1n().s[109]++;
          _this2.node = node;
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 507,
          columnNumber: 7
        }
      }, IconDropdown, (cov_21ccn4jg1n().b[68][0]++, this.state.isOpen) && (cov_21ccn4jg1n().b[68][1]++, /*#__PURE__*/_react.default.createElement(_DropDown.default, {
        options: (cov_21ccn4jg1n().b[69][0]++, noOptionsAvailable) || (cov_21ccn4jg1n().b[69][1]++, options),
        selectedItems: selectedItems,
        onSelectedValue: function onSelectedValue(value) {
          cov_21ccn4jg1n().f[50]++;
          cov_21ccn4jg1n().s[110]++;
          return _this2.onSelectedValue(value);
        },
        single: true,
        isIconDropdown: true,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 517,
          columnNumber: 11
        }
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      cov_21ccn4jg1n().f[34]++;
      cov_21ccn4jg1n().s[49]++;
      if ((cov_21ccn4jg1n().b[37][0]++, nextProps.selectedValues) && (cov_21ccn4jg1n().b[37][1]++, nextProps.selectedValues !== '')) {
        cov_21ccn4jg1n().b[36][0]++;
        cov_21ccn4jg1n().s[50]++;
        return {
          selectedItems: nextProps.selectedValues,
          isOpen: nextProps.isOpen !== undefined ? (cov_21ccn4jg1n().b[38][0]++, nextProps.isOpen) : (cov_21ccn4jg1n().b[38][1]++, state.isOpen)
        };
      } else {
        cov_21ccn4jg1n().b[36][1]++;
      }
      cov_21ccn4jg1n().s[51]++;
      return null;
    }
  }]);
}(_react.Component);
cov_21ccn4jg1n().s[111]++;
MultiDropDown.propTypes = {
  /**
   * Show placeholder for the Selector
   */
  placeholder: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  /**
   * Method to be called when click over an option
   */
  onSelectedValue: _propTypes.default.func,
  /**
   * Array of values to show the options
   */
  options: _propTypes.default.arrayOf(_propTypes.default.oneOfType([(_type.SingleOptionType, _type.MultipleOptionType)])).isRequired,
  /**
   * Indicate if accept single selection
   */
  single: _propTypes.default.bool,
  /**
   * Indicate if the dropdown is open
   */
  isOpen: _propTypes.default.bool,
  /**
   * Array with values selected
   */
  selectedValues: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_type.SingleOptionType), _propTypes.default.string]),
  /** if passed as parameter, the parent will manage the visibility of the component with the prop 'visible' */
  onClose: _propTypes.default.func,
  /* Custom display for selected values */
  customSelectedValues: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  /* Left icon */
  leftIcon: _propTypes.default.node,
  /* Instead of a collapsible panel we display only a icon for multi-dropdown */
  IconDropdown: _propTypes.default.node,
  /* Function to handle toggle select */
  toggleSelect: _propTypes.default.func,
  /* Help text for icon dropdown */
  message: _propTypes.default.shape({}),
  /** Keep place holder when filled */
  keepPlaceholder: _propTypes.default.bool,
  /** Theme context */
  themeQueries: _utils.WithThemeQueriesType
};
cov_21ccn4jg1n().s[112]++;
MultiDropDown.defaultProps = {
  placeholder: '',
  onSelectedValue: function onSelectedValue() {
    cov_21ccn4jg1n().f[51]++;
  },
  options: [],
  single: false,
  selectedValues: [],
  isOpen: false,
  onClose: undefined,
  customSelectedValues: undefined,
  leftIcon: null,
  IconDropdown: null,
  toggleSelect: function toggleSelect() {
    cov_21ccn4jg1n().f[52]++;
  },
  message: {},
  keepPlaceholder: true,
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  themeQueries: {}
};
var _default = exports.default = (0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)(MultiDropDown));